<template>
	<div class="conserve-wrapper">
		<div class="nav" style="height: auto">
			<div class="nav-center">养护评吸列表</div>
		</div>
		<transition name="slide-fade">
			<div class="inspection-cen">
				<div class="warn-top">
					<div class="input-date-wrapper">
						<el-date-picker v-model="value" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
						 end-placeholder="结束日期">
						</el-date-picker>
					</div>
					<div class="input-wrapper">
						<input v-model="YanyeCode" placeholder="请输入烟叶代码" />
					</div>
					<div class="input-wrapper" style="margin-left: 1.25rem;">
						<input v-model="DuoweiName" placeholder="请输入垛位名称" />
					</div>
					<div class="query" style="margin-left: 1vw" @click="handleSearch(1)">查询</div>
				</div>
				<div class="detail">
					<div class="detail-box">
						<div class="loading-data" v-if="loading">
							<i class="el-icon-loading"></i>
							<div>加载中，请稍后···</div>
						</div>
						<div class="detail-nav">
							<div class="detail-item" style="width: 5%">序号</div>
							<div class="detail-item" style="width: 15%">烟叶代码</div>
							<div class="detail-item" style="width: 20%">垛位名称</div>
							<div class="detail-item" style="width: 10%">养护天数</div>
							<div class="detail-item" style="width: 10%">养护件数</div>
							<div class="detail-item" style="width: 10%">养护人</div>
							<div class="detail-item" style="width: 15%">评吸意见</div>
							<div class="detail-item" style="width: 20%">操作</div>
						</div>
						<div class="detail-content">
							<div class="detail-list-wrapper" v-if="!loading && tableData.length>0" v-for="(data,index) in tableData" :key="index">
								<div class="detail-item" style="width: 5%">{{index+1}}</div>
								<div class="detail-item" style="width: 15%">{{data.materialCode}}</div>
								<div class="detail-item" style="width: 20%">{{data.siteName}}</div>
								<div class="detail-item" style="width: 10%">{{data.alreadyMaintainDays}}</div>
								<div class="detail-item" style="width: 10%">{{data.maintainCount}}</div>
								<div class="detail-item" style="width: 10%">{{data.principalName}}</div>
								<div class="detail-item" style="width: 15%">{{data.content}}</div>
								<div class="detail-item" style="width: 20%">
									<div class="detail-btn item-look" @click="todueLook(data.id)">查看</div>
								</div>
							</div>
							<div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
						</div>
						<div class="page-wrapper" v-if="!loading && total > rows">
							<div class="page-wrapper-left">共{{total}}条数据，每页显示{{rows}}条，当前第{{page}}页</div>
							<div class="page-wrapper-right">
								<div class="page-btn" @click="firstPage">首页</div>
								<div class="page-btn" @click="previousPage">上一页</div>
								<div class="page-btn" @click="nextPage">下一页</div>
								<div class="page-btn" @click="lastPage">尾页</div>
							</div>
						</div>
					</div>
					<transition name="fade">
						<div class="alert-box" v-if="show">
							<div class="alert-content">
								<div class="alert-content-title">删除提醒</div>
								<div class="alert-content-msg">是否确认删除选中数据?</div>
								<div class="alert-content-btn">
									<div class="btn-cancel button" @click="cancelDelete">取消</div>
									<div class="btn-confirm button" @click="confirmDelete">确认</div>
								</div>
							</div>
						</div>
					</transition>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	import DropDown from '../../../components/DropDownSingle.vue'
	import {
		getPinXiData
	} from '../../../api/maintain'
	export default {
		name: 'PlanSingle',
		components: {
			DropDown
		},
		data() {
			return {
				className: 'parallelogram-btn-right_',
				change: 0,
				value: '',
				show: false,
				all: false,
				id: '',
				type: 0,
				idList: [],
				approveStatusData: [{
						name: '全部',
						value: ''
					},
					{
						name: '未审核',
						value: 0
					},
					{
						name: '已审核',
						value: 1
					},
					{
						name: '已拒绝',
						value: 2
					}
				],
				maintainStageData: [{
						name: '全部',
						value: ''
					},
					{
						name: '自然醇化阶段',
						value: '01'
					},
					{
						name: '防霉杀虫阶段',
						value: '02'
					},
					{
						name: '气调醇化阶段',
						value: '03'
					},
					{
						name: '气调保质阶段',
						value: '04'
					}
				],
				loading: true,
				// keyword: '',
				// 烟叶代码
				YanyeCode: '',
				// 垛位名称
				DuoweiName: '',
				approveStatus: '',
				maintainStage: '',
				startTime: '',
				endTime: '',
				page: 1,
				rows: 9,
				total: '',
				tableData: []
			}
		},
		created() {
			this.handleSearch(1)
		},
		watch: {
			value: function() {
				console.log(this.value)
				this.startTime = this.value !== null ? this.value[0] : ''
				this.endTime = this.value !== null ? this.value[1] : ''
			}
		},
		methods: {
			todueLook: function(id) {
				this.$router.push({
					path: '/pinxi/dueLookpinxi',
					query: {
						index: '6',
						id: id
					}
				})
			},
			handleSearch: function(type) {
				if (type === 1) {
					this.page = 1
				}
				// 品吸查询参数体
				let body = {
					page: this.page,
					rows: this.rows,
					// 参数烟叶代码
					keyword: this.YanyeCode,
					// 参数垛位名称
					siteName: this.DuoweiName,
					startTime: this.startTime,
					endTime: this.endTime
				}
				this.loading = true
				getPinXiData(body).then(res => {
					console.log(res)
					res.data.rows && res.data.rows.map(item => {
						item.sign = 0
					})
					this.tableData = res.data.rows || []
					this.total = res.data.total
					this.loading = false
					this.all = false
					this.idList = []
				}).catch(err => {
					console.log(err)
				})
			},
			firstPage: function() {
				console.log('首页')
				if (this.page === 1) {
					this.$message({
						message: '当前为第一页',
						type: 'warning',
						center: 'true',
						duration: '1000'
					})
				} else {
					this.page = 1
					this.handleSearch()
				}
			},
			previousPage: function() {
				console.log('上一页')
				if (this.page < 2) {
					this.$message({
						message: '当前为第一页',
						type: 'warning',
						center: 'true',
						duration: '1000'
					})
				} else {
					this.page--
					this.handleSearch()
				}
			},
			nextPage: function() {
				console.log('下一页')
				if (parseInt(this.total / this.rows) + 1 > this.page) {
					this.page++
					this.handleSearch()
				} else {
					this.$message({
						message: '当前为最后一页',
						type: 'warning',
						center: 'true',
						duration: '1000'
					})
				}
			},
			lastPage: function() {
				console.log('尾页')
				if (this.page === parseInt(this.total / this.rows) + 1) {
					this.$message({
						message: '当前为最后一页',
						type: 'warning',
						center: 'true',
						duration: '1000'
					})
				} else {
					if (Math.round(this.total % this.rows) === 0) {
						this.page = parseInt(this.total / this.rows)
					} else {
						this.page = parseInt(this.total / this.rows) + 1
					}
					this.handleSearch()
				}
			}
		}
	}
</script>

<style scoped>
	@import "Conserve.css"
</style>



// WEBPACK FOOTER //
// src/page/maintain/pinxi/PlanSingle.vue